<template>
  <v-list-item class="pl-0 pr-0 text-truncate">
    <v-list-item-icon
      v-if="!category.icon_custom_url && category.icon"
      class="d-none d-md-block"
    >
      <v-icon>{{ category.icon }}</v-icon>
    </v-list-item-icon>
    <v-list-item-icon
      v-if="category.icon_custom_url"
      class="d-none d-md-block"
    >
      <img
        :src="category.icon_custom_url"
        style="height: 27px; width: 27px"
      >
    </v-list-item-icon>
    <v-list-item-title class="font-weight-medium">
      <span class="text-truncate">{{ category.default_translation.name }}</span>
      ({{ count }})
    </v-list-item-title>
    <v-list-item-action>
      <v-btn
        icon
        small
        :disabled="filterActive"
        @click.prevent.stop="handleMoveItemUp"
      >
        <v-icon>
          mdi-arrow-up
        </v-icon>
      </v-btn>
    </v-list-item-action>
    <v-list-item-action>
      <v-btn
        icon
        small
        :disabled="filterActive"
        @click.prevent.stop="handleMoveItemDown"
      >
        <v-icon>
          mdi-arrow-down
        </v-icon>
      </v-btn>
    </v-list-item-action>
    <v-list-item-action>
      <v-btn
        ref="btn"
        icon
        small
        @click.prevent.stop="handleShowOptionsMenu"
      >
        <v-icon>mdi-dots-vertical</v-icon>
      </v-btn>
    </v-list-item-action>
  </v-list-item>
</template>

<script>
export default {
  props: {
    category: {
      type: Object,
      required: true
    },
    isSubcategory: {
      type: Boolean
    },
    categoryIndex: {
      type: Number,
      required: true
    },
    subcategoryIndex: {
      type: Number,
      required: false,
      default: null
    },
    filterActive: {
      type: Boolean
    }
  },

  computed: {
    type() {
      return this.isSubcategory ? 'subcategory' : 'category';
    },

    count() {
      if (this.isSubcategory) {
        return this.category.questions.length;
      }

      const subcatsTotalQuestionsCount = this.category.subcategories.reduce((acc, subcat) => {
        return acc + subcat.questions.length;
      }, 0);

      return this.category.questions.length + subcatsTotalQuestionsCount;
    }
  },

  methods: {
    handleShowOptionsMenu() {
      this.$emit('show-options-menu', this.type, this.category, this.$refs.btn.$el);
    },

    eventPayload() {
      const payload = {
        type: this.type,
        catIdx: this.categoryIndex,
        subcatIdx: this.subcategoryIndex
      };

      return payload;
    },

    handleMoveItemUp() {
      this.$emit('move-item-up', this.eventPayload());
    },

    handleMoveItemDown() {
      this.$emit('move-item-down', this.eventPayload());
    }
  }
}
</script>